export default class ENUM {
  static MODE = {
    RESTAURANT: 'RESTAURANT', // MINISITE
    COUNTRY: 'COUNTRY' // VERSION2
  }

  static DeliveryMethod = Object.freeze({
    /**
     * @enum DeliveryMethod.Type
     * @property {Number} Type.Delivery
     * @property {Number} Type.DeliveryAndPickup
     * @property {Number} Type.Pickup
     */
    Type: {
      Delivery: 1,
      DeliveryAndPickup: 2,
      Pickup: 3
    }
  })

  static PAGE = Object.freeze({
    UNKNOWN: 'UNKNOWN',
    MENU: 'MENU',
    CHECKOUT: 'CHECKOUT',
    SUCCESS: 'SUCCESS'
  })

  /**
   * @enum
   * @property {string} Basket the name how the basket will be saved in the local storage.
   * @property {string} LAST_INTERACTION_TIME the name how the last interaction time will be saved in the local storage.
   */
  static Persistence = Object.freeze({
    BASKET: 'Basket',
    LAST_INTERACTION_TIME: 'BasketLastInteractionTime'
  })
}
